// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfk_a"};